import { motion } from "framer-motion";
import React from "react";
import { homeAni } from "./animation";
import { Mail } from "./Icons/Mail";

function MailComp({ transition, exit }) {
  return (
    <>
      <motion.div
        className="mail--wrapper"
        variants={homeAni}
        initial="initial"
        animate="animate"
        exit={{
          ...exit,
        }}
        transition={{ ...transition }}
      >
        <motion.a href="mailto:yadprabdev@gmail.com">
          <Mail />
          yadprabdev@gmail.com
        </motion.a>
      </motion.div>
    </>
  );
}

export default MailComp;
